import './Footer.css';

// "Use old design" escape hatch removed 18 Aug 2026 with the /legacy retirement.
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <a
          href="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link"
        >
          Privacy Policy
        </a>
      </div>
    </footer>
  );
};

export default Footer;
